// Angular Imports
import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class LoaderService {
    state = signal(false);

    private lastShowTime = 0;
    private minLoaderTime = 500;

    show() {
        this.lastShowTime = Date.now();
        this.state.set(true);
    }

    hide() {
        const elapsed = Date.now() - this.lastShowTime;
        const remainingTime = this.minLoaderTime - elapsed;

        if (remainingTime > 0) {
            setTimeout(() => this.state.set(false), remainingTime);
        } else {
            this.state.set(false);
        }
    }
}
